import { createFileRoute } from "@tanstack/react-router";
import { options } from "@/pages/best-free-gif-maker";

export const Route = createFileRoute("/blog/best-free-gif-maker")(options);
